import React from 'react';
import { Link } from 'react-router-dom';
import { TERMS_TEXT } from '../constants/termsText';

const TermsConditionsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      <header className="bg-gray-200 p-4 sm:p-6 flex justify-between items-center">
        <div className="flex items-center">
          <a href="https://www.ashadegreener.co.uk">
            <img
              src="/ASG_Maintenance_side.png"
              alt="A Shade Greener Maintenance"
              className="h-16 sm:h-20 w-auto"
            />
          </a>
        </div>
        <Link to="/login" className="text-sm text-gray-600 hover:text-gray-900">
          Back to Login
        </Link>
      </header>

      <main className="flex-1 px-4 py-8 sm:py-12">
        <div className="max-w-3xl mx-auto bg-white rounded-lg shadow-sm p-6 sm:p-10">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-6">
            Terms and Conditions
          </h1>
          <div className="text-sm sm:text-base text-gray-700 whitespace-pre-line leading-relaxed">
            {TERMS_TEXT}
          </div>
        </div>
      </main>

      <footer className="bg-gray-800 text-white text-center py-4 text-sm">
        <p className="opacity-60">
          Sterling House, Maple Court, Tankersley, S75 3DP |{' '}
          <a href="https://www.ashadegreener.co.uk/privacy" target="_blank" rel="noopener noreferrer" className="hover:opacity-100">
            Privacy Policy
          </a>
        </p>
      </footer>
    </div>
  );
};

export default TermsConditionsPage;
